export default __webpack_public_path__ + "static/media/Girls_Juggler.7b60a55d.svg";